import React, { useRef } from "react";
import useClickOutside from "../../hooks/useClickOutside";
import EmojiPicker, { EmojiStyle } from "emoji-picker-react";
import { BlackPlus, PlusIcon } from "../../assets";
import { useTheme } from "../../context/ThemeProvider";

const EmojiPickerComponent = ({
  onEmojiSelect,
  selectedEmoji,
  className = "",
  id,
}) => {
  const { theme } = useTheme();
  const [showPicker, setShowPicker] = React.useState(false);

  const pickerRef = useRef(null);
  const buttonRef = useRef(null);

  const onEmojiClick = (emojiObject) => {
    if (onEmojiSelect) {
      onEmojiSelect(emojiObject);
    }
    setShowPicker(false);
  };

  const togglePicker = () => {
    setShowPicker(!showPicker);
  };

  useClickOutside([pickerRef, buttonRef], () => setShowPicker(false), showPicker);

  return (
    <div className={`relative ${className}`}>
      <button
        id={id}
        ref={buttonRef}
        onClick={togglePicker}
        type="button"
        className="flex items-center justify-center w-[38px] h-[38px] bg-fill-add-surface text-ink-gray-600 hover:text-ink-gray-800 hover:bg-fill-gray-200 rounded-full transition-all duration-150 focus:outline-none text-xl"
        title="Add emoji"
      >
        {selectedEmoji ? (
          <img
            src={selectedEmoji.imageUrl}
            alt={selectedEmoji.unified}
            className="w-5 h-5"
          />
        ) : theme === "dark" ? (
          <BlackPlus />
        ) : (
          <PlusIcon />
        )}
      </button>

      {showPicker && (
        <div
          ref={pickerRef}
          className="absolute top-full min-w-80 right-0 mt-2 z-50 rounded-lg overflow-hidden shadow-xl bg-fill-white"
        >
          <EmojiPicker
            onEmojiClick={onEmojiClick}
            emojiStyle={EmojiStyle.GOOGLE}
            width={320}
            height={300}
            searchDisabled={false}
            skinTonesDisabled={true}
            previewConfig={{
              showPreview: false,
            }}
            theme={theme === "dark" ? "dark" : "light"}
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPickerComponent;
